export default "__VITE_ASSET__CPFbW7Zu__"